import { ref } from 'vue';

const msalAccountUsername = ref<string>('');

export function useMsalAccountUsername() {
  const setMsalAccountUsername = (username: string) => {
    msalAccountUsername.value = username;
  };

  return {
    msalAccountUsername,
    setMsalAccountUsername,
  };
}
